module.exports = __webpack_public_path__ + "img/intelligent-bg.c70176f9.png";